import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import Bookmark from "../models/bookmark.model";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { WhereList } from "../models/pagination";
import { environment } from "../../environments/environment";
import { NotificationService } from "./notifications.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class BookmarkService {
  visibility = environment.visibility;
  baseUrl = environment.apiUrl;
  userLogin: User;
  private dbPath = "/bookmarks";

  collRef: AngularFirestoreCollection<Bookmark>;

  constructor(
    private http: HttpClient,
    private db: AngularFirestore,
    private userStore: UserService,
    private notiService: NotificationService
  ) {
    this.collRef = db.collection(this.dbPath);

    this.userStore.getCurrentUser().subscribe((user: User) => {
      this.userLogin = user;
    });
  }

  getBookmarks(
    wheres: WhereList[],
    limit?: number,
    cursor?: any
  ): AngularFirestoreCollection<Bookmark> {
    return this.db.collection(this.dbPath, (ref) => {
      let query: CollectionReference | Query = ref;

      query = query.where("isDeleted", "==", false);
      query = query.where("isActive", "==", true);
      query = query.where("value", "==", true);

      for (var i = 0; i < wheres.length; i++) {
        query = query.where(wheres[i].fieldPath, "==", wheres[i].value);
      }

      query = query.orderBy("updatedOn", "desc");

      query = limit ? query.limit(limit) : query.limit(10);
      if (cursor != null) query = query.startAfter(cursor);

      return query;
    });
  }

  getMyBookmark(mode: string, refId: string, uid: string): any {
    const createdBy = this.userLogin ? this.userLogin.uid : uid;

    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("mode", "==", mode)
      .where("refId", "==", refId)
      .where("createdBy", "==", createdBy)
      .orderBy("updatedOn", "desc")
      .limit(1);

    return ref.get();
  }

  get(id: string) {
    return this.collRef.doc(id).valueChanges();
  }

  create(bookmark: Bookmark): any {
    // bookmark.id ? delete bookmark.id : null;

    bookmark.refAuthor = bookmark.refAuthor ? bookmark.refAuthor : null;

    bookmark.value = true;
    bookmark.isActive = true;
    bookmark.isDeleted = false;
    bookmark.createdOn = new Date();
    bookmark.createdBy = this.userLogin.uid;
    bookmark.updatedOn = new Date();
    bookmark.updatedBy = this.userLogin.uid;
    bookmark.author = this.userLogin;
    bookmark.visibility = this.visibility;

    console.log("BookmarkService/create", bookmark);

    return this.collRef.add({ ...bookmark }).then((docRef) => {
      bookmark.id = docRef.id;

      const syncData = { id: bookmark.id, ...bookmark };
      this.sync(syncData);

      return bookmark;
    });
  }

  checkBookmark(bookmark: Bookmark): Promise<void> {
    console.log("checkBookmark:", bookmark);
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.collRef
      .doc(bookmark.id)
      .update({
        refTitle: bookmark.refTitle,
        refDescription: bookmark.refDescription,
        refAuthor: bookmark.refAuthor,
        value: true,
        updatedOn: updatedOn,
        updatedBy: updatedBy,
      })
      .then((docRef) => {
        bookmark.createdBy = bookmark.createdBy
          ? bookmark.createdBy
          : updatedBy;
        const syncData = { id: bookmark.id, ...bookmark };
        this.sync(syncData);

        return docRef;
      });
  }

  uncheckBookmark(bookmark: Bookmark): Promise<void> {
    console.log("uncheckBookmark:", bookmark);
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.collRef
      .doc(bookmark.id)
      .update({
        value: false,
        updatedOn: updatedOn,
        updatedBy: updatedBy,
      })
      .then((docRef) => {
        bookmark.createdBy = bookmark.createdBy
          ? bookmark.createdBy
          : updatedBy;
        const syncData = { id: bookmark.id, ...bookmark };
        this.sync(syncData);

        return docRef;
      });
  }

  sync(content) {
    content.createdOn ? delete content.createdOn : null;
    content.updatedOn ? delete content.updatedOn : null;

    content.fsId = content.id ? content.id : "";

    if (environment.syncLive) {
      this.http.post(this.baseUrl + "/Bookmarks", content).subscribe({
        next: () => {},
        error: (err) => {},
      });
    }
  }
}
